import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import styles from './ViewAllButton.module.scss';

const ViewAllButton = ({ link }: { link: string }) => {
  const { t } = useTranslation();

  return (
    <div className={styles.root}>
      <Link className={styles.viewAll} to={link}>
        {t('viewAll')}
      </Link>
    </div>
  );
};

export default ViewAllButton;
